/**
 * @fileoverview The page's source, as a file. See `exportPage.ts`.
 *
 * Offered to every reader of a page, because export is a reader capability: a
 * page you can read is a page you could have copied out by hand, and the file
 * only spares you the copying. A private page is exported decrypted, to the
 * reader who already holds its key.
 */

import { downloadExport, exportPage } from '@/services/pages/exportPage';
import type { PageIndex } from '@/services/pages/indexEvent';

export function ExportLink({ index, body }: { index: PageIndex; body: string }) {
  return (
    <button type="button" className="page-export-link" onClick={() => downloadExport(exportPage(index, body))}>
      {index.format === 'html' ? 'Download HTML' : 'Download markdown'}
    </button>
  );
}
